import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const ChevronUp14 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={14}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M7.01001 3.91934L10.5403 7.44967L9.47968 8.51033L7.01001 6.04066L4.54034 8.51033L3.47968 7.44967L7.01001 3.91934Z'
      fill='currentColor'
    />
  </Svg>
);

ChevronUp14.displayName = 'ChevronUp14';
export default ChevronUp14;
